document.addEventListener('click', function(e) {
    const dataHrefElement = e.target.closest('[data-href]');
    
    if (dataHrefElement) {
        const exclude = dataHrefElement.getAttribute('data-href-exclude');
        if (exclude) {
            const excludeClasses = exclude.split(',').map(cls => cls.trim());
            if (excludeClasses.some(cls => e.target.closest(`.${cls}`))) return;
        }
    }

    if (dataHrefElement) {
        // If the click is on or inside an <a>, <button>, or <input> within the data-href element, let it behave natively
        const clickedInteractive = e.target.closest('a, button, input');
        if (clickedInteractive && dataHrefElement.contains(clickedInteractive)) return;

        e.preventDefault();

        const link = dataHrefElement.querySelector('a:not([href^="tel:"]):not([href^="mailto:"]):not([x-apple-data-detectors])');
        if (link) {
            const href = link.getAttribute('href');
            const target = link.getAttribute('target') || '_self';
            window.open(href, target);
        }
    }
});

document.addEventListener('click', function(e) {
    const element = e.target.closest('[data-href-simulated-click]');
    
    if (element) {
        const exclude = element.getAttribute("data-href-simulated-click");
        if (e.target.classList.contains(exclude) && exclude !== '') {
            return;
        } else {
            e.preventDefault();
            
            const link = element.querySelector('a:not([href^="tel:"]):not([href^="mailto:"]):not([x-apple-data-detectors])');
            if (link) {
                // Simulate the click event on the link
                link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
            }
        }
    }
});